import React from "react";
import { BlockedMode, RenderArgs } from "./BenefitGate.types";
import { EBenefitTypes } from "../enums/benefits.enums";

const DISABLABLE_DOM = new Set([
    "button",
    "input",
    "select",
    "textarea",
    "option",
    "fieldset",
]);

export function canInjectDisabled(el: React.ReactElement): boolean {
    const t: any = el.type;

    if (typeof t === "string") return DISABLABLE_DOM.has(t);

    // Heurística conservadora: si el prop existe, probablemente el componente lo soporta (MUI)
    if (el.props && Object.prototype.hasOwnProperty.call(el.props, "disabled")) return true;

    return false;
}

export type BaseGateProps = {
    benefit: EBenefitTypes;
    showWhenBlocked?: BlockedMode;
    blockedTooltip?: string | ((args: RenderArgs) => string);

    sx?: any;

    children: React.ReactElement | ((args: RenderArgs) => React.ReactElement);
};

export type OverlayGateProps = BaseGateProps & {
    overlay?: boolean;
    overlayLabel?: string | ((args: RenderArgs) => string);
    overlaySx?: any;
    action?: React.ReactNode;
};
